export default function calculateVertex({ angle, distance, heading, cameraMarkerPosition, showAnalyticZones }) {
  const leftPosition = google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, distance, heading - (angle / 2))
  const rightPosition = google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, distance, heading + (angle / 2))

  const paths = { cameraMarkerPosition, leftPosition, rightPosition }

  let a = heading + angle / 2
  const circlePoints = []

  while (a > heading - angle / 2) {
    circlePoints.push(google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, distance, a))
    a--
  }

  // add in final point to deal with non-integer values
  circlePoints.push(google.maps.geometry.spherical.computeOffset(cameraMarkerPosition, distance, heading - angle / 2))

  if (showAnalyticZones) return circlePoints

  if (angle === 180) {
    circlePoints.push(circlePoints[0])
    paths.halfCircle = circlePoints
  } else {
    circlePoints.push(cameraMarkerPosition)
    paths.endAngle = circlePoints
  }

  return paths
}



// WEBPACK FOOTER //
// ./src/components/Camera/helpers/calculateVertex.js